import { lazy, Suspense, type ComponentType, type ReactNode } from 'react';

type PageModule<ExportName extends string> = Record<ExportName, ComponentType>;

export const lazyNamedPage = <ExportName extends string>(
  load: () => Promise<PageModule<ExportName>>,
  exportName: ExportName
) =>
  lazy(async () => {
    const module = await load();

    return { default: module[exportName] };
  });

export const renderLazyPage = (page: ReactNode, fallback: ReactNode = null) => (
  <Suspense fallback={fallback}>{page}</Suspense>
);
